<template>
    <div>
        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                persistent
                max-width="330px">
                <v-card class="padding-card">
                    <h4>{{ $vuetify.lang.t('$vuetify.overtimeRequestForm.otRequestCannotApprove')}}</h4>
                    <div>
                        <div v-for="(listOverlap, key) in groupOverlap" :key = key>
                            <p>{{ $vuetify.lang.t(`$vuetify.overtimeRequestForm.${key}`)}}</p>
                            <ul>
                                <li v-for="overlapDate in listOverlap" :key = overlapDate>
                                    {{overlapDate}}
                                </li>
                            </ul>
                        </div>
                    </div>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            @click="dialog = false">
                            {{ $vuetify.lang.t('$vuetify.errorModal.close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
export default {
    props: {
        groupOverlap: {
            type: Object,
            default: Object
        }
    },
    data () {
        return {
            dialog: false
        }
    },
    methods: {
        submitBtn () {
            this.dialog = false
        }
    }
}
</script>

<style lang="scss" scoped>
.padding-card {
    padding: 10px;
}
</style>
